import React from 'react';

export default class LoadingAnimation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            height: props.height ? props.height : '500px'
        }
    }

    render() {
        return (
            <div className="position-relative" style={{display: 'table', width: '100%', height: '100%', minHeight: this.state.height}}>
                {this.props.loadingText ? <span className="position-absolute">{this.props.loadingText}</span> : null}
                <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
                    <i style={{width: '100%', marginLeft: 'auto', marginRight: 'auto'}} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw pt-5 pb-5"></i>
                </div>
            </div>
        );
    }
}